import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex';
import ClientPicker from '@/components/client/picker/ClientPicker.vue'
import SingleFileupload from '@/components/common/fileupload/single/SingleFileupload.vue';

const defaultPhone = {
  id: null,
  number: ''
}

const defaultClient = {
  client: {},
  pivot: { jobPosition: '', isResponsiblePerson: 0, receiveBill: 0, isContactPerson: 0, canFillReports: 0, receiveNotifications: 0 }
}

export default {
  data () {
    return {
      editEl: null,
      clientApiId: null,
      loading: false,
      roleData: [],
      password: '',
      passwordRepeat: '',
      sendAsMyself: true
    }
  },
  props: {
    isModal: Boolean
  },
  components: {
    ClientPicker,
    SingleFileupload
  },
  validations: {
    editEl: {
      name: { required },
      email: { required },
      passwordRepeat: {
        sameAsPassword: function (value, vm) {
          return (value === vm.password)
        },
        validatepassword: function (value, vm) {
          /*
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return (value.length === 0 || (value.length > 5 && containsUppercase && containsLowercase && containsNumber && containsSpecial));
           */
          return (value.length === 0 || value.length > 5);
        }
      }
    }
  },
  computed: {
    ...mapState(['config']),
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    getTitle () {
      if (this.editEl && this.editEl.id) {
        return this.$t('menu.user.edit');
      }
      return this.$t('menu.user.new');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    isMyData () {
      return (this.editEl && this.$session.get('uuid') === this.editEl.api_id)
    },
    canEdit () {
      return ((this.isMyData || (this.ApiRequest.userHasPermission('edit-settings', this.clientApiId, []))) && !this.loading);
    },
    canEditSettings () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    defaultEl () {
      const el = {
        api_id: null,
        name: '',
        email: '',
        seminarRejectInvite: false,
        phones: [],
        photo: null,
        roles: []
      };
      if (this.clientApiId) {
        el.pivot = this.BasicHelper.cloneObject(defaultClient.pivot);
      } else {
        el.isContactPerson = 0;
        el.jobPosition = {};
        el.clients = [];
      }
      if (this.canEditSettings) {
        el.roles = [];
      }

      return el;
    }
  },
  methods: {
    show (elData, clientApiId = null) {
      this.clientApiId = clientApiId;
      let clientEl = null;
      if (elData) {
        clientEl = this.BasicHelper.cloneObject(elData);
      } else {
        clientEl = this.BasicHelper.cloneObject(this.defaultEl);
      }
      clientEl.seminarRejectInvite = (clientEl.seminarRejectInvite === 1);
      clientEl.isContactPerson = (clientEl.isContactPerson === 1);
      this.roleData = [];
      const self = this;
      clientEl.roles.forEach(function (el) {
        self.roleData[el.name] = true;
      });
      if (!this.clientApiId) {
        clientEl.clients.forEach(function (el, key) {
          clientEl.clients[key].client = self.BasicHelper.cloneObject(el);
        });
      }
      clientEl.password = '';
      clientEl.passwordRepeat = '';
      clientEl.seminarRejectInvite = (clientEl.seminarRejectInvite === 1);
      this.editEl = clientEl;
      this.$v.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        let path = 'user';
        if (this.clientApiId !== null) {
          path = 'client/single/' + this.clientApiId + '/user';
        }

        const reqData = {};
        for (const key of Object.keys(this.defaultEl)) {
          if (key === 'roles') {
            reqData.roles = [];
            for (const keyR of Object.keys(this.roleData)) {
              if (this.roleData[keyR]) {
                reqData.roles.push(keyR);
              }
            }
          } else {
            reqData[key] = this.editEl[key];
          }
        }

        if (this.editEl.password) {
          reqData.password = this.editEl.password;
          reqData.passwordRepeat = this.editEl.passwordRepeat;
        }

        reqData.files = (this.editEl.photo ? [this.editEl.photo] : []);
        const formData = this.ApiRequest.createFormData(reqData, Object.keys(reqData), 'user', this, false);

        const self = this;
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, formData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            if (self.isModal) {
              self.close();
            } else {
              self.editEl.password = '';
              self.editEl.passwordRepeat = '';
            }
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    addPhone () {
      this.editEl.phones.push(this.BasicHelper.cloneObject(defaultPhone));
    },
    deletePhone (idx) {
      this.editEl.phones.splice(idx, 1);
    },
    addClient () {
      this.editEl.clients.push(this.BasicHelper.cloneObject(defaultClient));
    },
    deleteClient (idx) {
      this.editEl.clients.splice(idx, 1);
    },
    generateUserInvite (editEl, approved) {
      if (approved) {
        this.loading = true;
        const self = this;
        const sendAsMyself = (this.canEditSettings ? this.sendAsMyself : false);
        this.ApiRequest.request('user/reset-password/invite/' + this.editEl.api_id, this.ApiRequest.REQUEST_POST, { sendAsMyself: sendAsMyself }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self)
          } else {
            self.ApiRequest.displaySuccessDialog(self, self.$t('user.invite-box.successMessage'), self.$t('user.invite-box.inviteTitle'));
          }
          self.loading = false;
        });
      } else {
        this.$refs.inviteUserMsgBox.show(
          this.editEl,
          this.$t('user.invite-box.inviteTitle'),
          this.$t('user.invite-box.inviteMessage', { name: this.editEl.name, email: this.editEl.email })
        );
      }
    },
    generateResetPassword (editEl, approved) {
      if (approved) {
        this.loading = true;
        const self = this;
        const sendAsMyself = (this.canEditSettings ? this.sendAsMyself : false);
        this.ApiRequest.request('user/reset-password/reset/' + this.editEl.api_id, this.ApiRequest.REQUEST_POST, { sendAsMyself: sendAsMyself }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self)
          } else {
            self.ApiRequest.displaySuccessDialog(self, self.$t('user.reset-password-box.resetSuccessMessage'), self.$t('user.reset-password-box.resetTitle'));
          }
          self.loading = false;
        });
      } else {
        this.$refs.resetPasswdMsgBox.show(
          this.editEl,
          this.$t('user.reset-password-box.resetTitle'),
          this.$t('user.reset-password-box.resetMessage', { name: this.editEl.name, email: this.editEl.email })
        );
      }
    }
  },
  mounted () {
    if (this.$route.path.indexOf('/user/my-edit') === 0) {
      const self = this;
      self.loading = true;
      this.ApiRequest.request('user/get', this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data && response.data) {
          self.show(response.data);
        }
        self.loading = false;
      });
    }
  }
}
